import { $sce } from '../../../ng-compat/imports'

export class QuotePrintController {
  public renderedTemplate!: string
  public receiptCSS: any
  private options: any
  constructor() {
    'ngInject'
  }

  public $onInit() {
    this.renderedTemplate = $sce.trustAsHtml(this.options)
  }
}
